import React from 'react';
import { Link } from 'react-router-dom';
import useAuth from '../hooks/useAuth';
import { doctorNameLabel } from '../utils/doctorInfo';
import './HomePage.css';

const HomePage = () => {
  const { isAuthenticated, user } = useAuth();
  const displayName = user?.role === 'doctor' ? doctorNameLabel(user?.full_name) : user?.full_name;

  return (
    <div className="home-page">
      <header className="home-topbar">
        <div className="home-topbar-inner">
          <Link to="/" className="home-brand" aria-label="Clínica Aurora — início">
            <span className="home-brand-mark" aria-hidden="true">+</span>
            <span><strong>Clínica Aurora</strong><small>Cuidado que acompanha você</small></span>
          </Link>
          <nav className="home-actions" aria-label="Acesso ao sistema">
            {isAuthenticated && <span className="home-welcome">Olá, {displayName}</span>}
            <Link to={isAuthenticated ? '/dashboard' : '/login'} className="home-login-button">
              {isAuthenticated ? 'Ir para o painel' : 'Acessar o portal'} <span aria-hidden="true">→</span>
            </Link>
          </nav>
        </div>
      </header>

      <main>
        <section className="home-hero">
          <div className="home-hero-copy">
            <span className="home-eyebrow">Saúde, organização e proximidade</span>
            <h1>O cuidado começa antes mesmo da consulta.</h1>
            <p>Uma experiência simples para acompanhar agendas, atendimentos e informações clínicas em um só lugar.</p>
            <div className="home-hero-actions">
              <Link to={isAuthenticated ? '/dashboard' : '/login'} className="home-primary-action">
                {isAuthenticated ? 'Abrir meu painel' : 'Entrar no sistema'}
              </Link>
              <a href="#recursos" className="home-text-link">Conhecer recursos <span aria-hidden="true">↓</span></a>
            </div>
          </div>

          <div className="home-hero-visual" aria-label="Visão geral dos serviços da clínica">
            <div className="home-visual-orbit" aria-hidden="true" />
            <div className="home-status-card home-status-card-main">
              <span className="home-status-icon" aria-hidden="true">+</span>
              <div><small>Portal integrado</small><strong>Seu cuidado em movimento</strong><p>Informações claras para cada etapa da jornada.</p></div>
            </div>
            <div className="home-status-card home-status-card-small">
              <span className="home-status-dot" aria-hidden="true" />
              <div><small>Atendimento</small><strong>Organizado e seguro</strong></div>
            </div>
          </div>
        </section>

        <section className="home-trust-row" aria-label="Benefícios do portal">
          <div><strong>Agenda</strong><span>Consultas organizadas</span></div>
          <div><strong>Atendimento</strong><span>Fluxo simples e ágil</span></div>
          <div><strong>Prontuário</strong><span>Histórico centralizado</span></div>
        </section>

        <section className="home-features" id="recursos">
          <div className="home-section-heading">
            <span className="home-eyebrow">Tudo conectado</span>
            <h2>Feito para facilitar a rotina da clínica.</h2>
            <p>Cada perfil encontra apenas o que precisa, com clareza e rapidez.</p>
          </div>
          <div className="home-feature-grid">
            <article className="home-feature-card"><span className="home-feature-number">01</span><h3>Agenda sem complicação</h3><p>Horários, confirmações e cancelamentos acompanhados em uma visão simples.</p></article>
            <article className="home-feature-card home-feature-card-highlight"><span className="home-feature-number">02</span><h3>Atendimento conectado</h3><p>Recepção e equipe médica acompanham o fluxo da consulta em tempo real.</p></article>
            <article className="home-feature-card"><span className="home-feature-number">03</span><h3>Informações protegidas</h3><p>Dados clínicos centralizados e acessíveis apenas para os perfis autorizados.</p></article>
          </div>
        </section>

        <section className="home-access-panel">
          <div><span className="home-eyebrow">Portal da clínica</span><h2>Já possui acesso?</h2><p>Entre com o e-mail e a senha fornecidos pela Clínica Aurora.</p></div>
          <Link to={isAuthenticated ? '/dashboard' : '/login'} className="home-primary-action home-primary-action-light">
            {isAuthenticated ? 'Acessar painel' : 'Fazer login'}
          </Link>
        </section>
      </main>

      <footer className="home-footer-new">
        <div><strong>Clínica Aurora</strong><span>Saúde e tecnologia trabalhando juntas.</span></div>
        <p>© 2026 Clínica Aurora · Desenvolvido por IRTECH Soluções Tecnológicas</p>
      </footer>
    </div>
  );
};

export default HomePage;
